module.exports = __webpack_public_path__ + "media/images/smart_phone/rank/icon_rank3-1d62dedcc367033de961221be0e3f0c2.png";